import { publishBotService } from '../../../services/nuvemshop/publishBot';

export function publishBotActions (email, botId, tokenPartners) { 
	return {
		type: 'PUBLISH_BOT',
		payload: publishBotService(email, botId, tokenPartners)
	}
}